import { jsxs, jsx } from "react/jsx-runtime";
import * as React from "react";
import { Segment } from "semantic-ui-react";
class Panel extends React.Component {
  render() {
    return /* @__PURE__ */ jsxs(Segment.Group, { id: this.props.id, className: this.props.className, children: [
      this.props.title && /* @__PURE__ */ jsx(Segment, { children: this.props.title }),
      this.props.children && /* @__PURE__ */ jsx(Segment, { secondary: this.props.secondary, children: this.props.children })
    ] });
  }
}
export {
  Panel
};
//# sourceMappingURL=Panel.js.map
